<template>
  <div class="my-title--com">
    <section class="title-wrap">
      <div class="title-main">
        <a class="main-left" href="/">
          <img width="40" height="40" src="https://image.qsyhbgj.com/logo947.png" alt="">
          <div class="right">
            <h1 class="name">生态环境公示网</h1>
          </div>
        </a>
      </div>
      <el-carousel height="122px" indicator-position="none" :interval="6000" style="position:relative;">
        <el-carousel-item v-for="(item, index) in list" :key="index">
          <img :src="item.photoUrl" alt="" @click="handleClick(item)" height="122px" width="70%" style="position:relative;left:15%;">
          <div v-if="item.message != ''" class="small" @click="handleClick(item)">{{ item.message }}</div>
        </el-carousel-item>
      </el-carousel>
      <div class="main-right-user-1">
        <div class="link-content-1" v-if="!userName">
          <span class="login" @click="doLogin" style="padding:0 10px 0 0">登录</span>
          <!-- <span class="register" @click="$router.push('/h5download?type=register')" style="padding:0 0 0 10px">注册</span> -->
          <span class="register" @click="doLogin1" style="padding:0 0 0 10px">注册</span>
        </div>
        <div class="link-content-1" v-else>
          <span class="login">{{userName}}</span>
          <span class="login" style="margin: 0 0 0 8px ;" @click="doLogout()">退出</span>
          <span class="login" style="margin: 0 0 0 8px ;" @click="$router.push('/h5public-personal')">我的</span>
          <!-- <span class="login" style="margin: 0 -104px 0 8px ;" @click="$router.push('/ehsMenuPage')">更多</span> -->
          <span class="login" style="margin: 0 -104px 0 8px ;">
            <div v-for="(item) in menuList" :key="item.id">
              <div @click="menuTabClicked(item.id)">{{ item.content }}</div>
              <div v-for="(subItem) in item.children" :key="subItem.id">
                <div v-if="menuTabId === item.id" @click="menuSubTabClicked(subItem)">{{ subItem.content }}</div>
              </div>
            </div>
          </span>
        </div>
      </div>
    </section>
    <!-- <div class="title-wrap">
      <img src="http://hbxz.qsyhbgj.com/admin/20220301/微信图片_20220301092646.jpg" height="136px" width="70%" style="position:relative;left:15%;">
    </div> -->
    <!-- <div class="title-wrap">
      <div class="title-main">
        <a class="main-left" href="/">
          <img width="40" height="40" src="https://image.qsyhbgj.com/logo947.png" alt="">
          <div class="right">
            <h1 class="name">生态环境公示网</h1>
          </div>
        </a>
        <div class="main-right-user">
          <div class="link-content" v-if="!userName">
            <span class="login" @click="doLogin">登录</span>
            <span class="register" @click="$router.push('/h5download?type=register')">注册</span>
          </div>
          <div class="link-content" v-else>
            <span class="login">{{userName}}</span>
          </div>
        </div>
      </div>
      <div class="title-link">
        <div class="link-line">
          <span class="link-title">
            国家生态环境网站：
          </span>
          <a href="http://www.mee.gov.cn/" target="_blank">生态环境部</a>
        </div>
        <div class="link-line">
          <span class="link-title">
            省级生态环境网站：
          </span>
          <a href="http://sthjj.beijing.gov.cn/" target="_blank">北京</a>
          <a href="http://sthj.tj.gov.cn/" target="_blank">天津</a>
          <a href="https://sthj.sh.gov.cn/" target="_blank">上海</a>
          <a href="http://sthjj.cq.gov.cn/" target="_blank">重庆</a>
          <a href="http://hbepb.hebei.gov.cn/" target="_blank">河北</a>
          <a href="https://sthjt.shanxi.gov.cn/" target="_blank">山西</a>
          <a href="http://sthj.ln.gov.cn/" target="_blank">辽宁</a>
          <a href="http://sthjt.jl.gov.cn/" target="_blank">吉林</a>
          <a href="http://www.hljdep.gov.cn/" target="_blank">黑龙江</a>
          <a href="http://hbt.jiangsu.gov.cn/" target="_blank">江苏</a>
          <a href="http://sthjt.zj.gov.cn/" target="_blank">浙江</a>
          <a href="http://sthjt.ah.gov.cn/" target="_blank">安徽</a>
          <a href="http://sthjt.fujian.gov.cn/" target="_blank">福建</a>
          <a href="http://sthjt.jiangxi.gov.cn/" target="_blank">江西</a>
          <a href="http://sthj.shandong.gov.cn/" target="_blank">山东</a>
          <a href="http://sthjt.henan.gov.cn/" target="_blank">河南</a>
          <a href="http://sthjt.hubei.gov.cn/" target="_blank">湖北</a>
          <a href="http://sthjt.hunan.gov.cn/" target="_blank">湖南</a>
          <a href="http://gdee.gd.gov.cn/" target="_blank">广东</a>
          <a href="http://hnsthb.hainan.gov.cn/" target="_blank">海南</a>
          <a href="http://sthjt.sc.gov.cn/" target="_blank">四川</a>
          <a href="http://sthj.guizhou.gov.cn/" target="_blank">贵州</a>
          <a href="http://sthjt.yn.gov.cn/index.html" target="_blank">云南</a>
          <a href="http://sthjt.shaanxi.gov.cn/" target="_blank">陕西</a>
          <a href="http://sthj.gansu.gov.cn/" target="_blank">甘肃</a>
          <a href="http://sthjt.qinghai.gov.cn/" target="_blank">青海</a>
          <a href="http://ee.xizang.gov.cn/sysweb/portal/index.htl" target="_blank">西藏自治区</a>
          <a href="http://sthjt.nmg.gov.cn/" target="_blank">内蒙古自治区</a>
          <a href="http://sthjt.gxzf.gov.cn/" target="_blank">广西壮族自治区</a>
          <a href="http://sthjt.nx.gov.cn/" target="_blank">宁夏回族自治区</a>
          <a href="http://sthjt.xinjiang.gov.cn/" target="_blank">新疆维吾尔自治区</a>
          <a href="http://hbj.xjbt.gov.cn/" target="_blank">新疆生产建设兵团</a>
        </div>
        <div class="link-line">
          <span class="link-title">
            友情链接：
          </span>
          <a href="http://permit.mee.gov.cn/permitExt/defaults/default-index!getInformation.action" target="_blank">排污许可平台</a>
          <a href="http://114.251.10.92:8080/XYPT/" target="_blank">环评信用平台</a>
          <a href="https://cepc.lem.org.cn/#/login" target="_blank">自主验收平台</a>
          <a href="http://www.soilinfo.cn/map/index.aspx" target="_blank">土壤信息平台</a>
          <a href="http://www.ceett.org.cn/huanbao/infomation/xscx.html" target="_blank">环境工程服务</a>
          <a href="http://cloud.lem.org.cn/" target="_blank">环境质量模拟</a>
        </div>
      </div>
    </div> -->
    <accountCom :showLogin.sync="loginDialogShow" @dispatchUserName="receiveName"></accountCom>
    <accountCom1 :showLogin.sync="loginDialogShow1" @dispatchUserName="receiveName"></accountCom1>
  </div>
</template>

<script>
import accountCom from '@/components/account/index'
import accountCom1 from '@/components/account/index1'
import api from '../../api/index'
export default {
  data () {
    return {
      menuTabId: 0,
      iframeSrc: '',
      menuSubTabId: 0,
      menuList: [
        {
          id: 1,
          index: '',
          content: '更多',
          showFlag: 1,
          children: [
            {
              id: 2,
              index: '/ehsMenuPage',
              content: '环保管家',
              showFlag: 1
            }, {
              id: 3,
              index: '/h5public-eiaExamine',
              content: '环评审核',
              showFlag: 1
            }
          ]
        }
      ],
      activeNumber: 0,
      tmier: null,
      bannerList: [],
      loginDialogShow: false,
      loginDialogShow1: false,
      userName: sessionStorage.getItem('qs_user_name')
    }
  },
  mounted () {
    api.getHotList({
      type: 'publicity'
    }).then(res => {
      if (res.code === 200) {
        this.bannerList = res.data
        console.log(123456)
        console.log(res.data[0].id)
        this.$emit('seeName', res.name)
      }
    })
  },
  methods: {
    menuTabClicked (id) {
      this.menuTabId = this.menuTabId === id ? 0 : id
    },
    menuSubTabClicked (item) {
      this.menuSubTabId = item.id
      console.log('路由', item.index)
      this.$router.push(item.index)
    },
    setTimer () {
      !this.timer && (this.timer = setInterval(() => {
        this.activeNumber++
        if (this.activeNumber >= this.list.length) {
          this.activeNumber = 0
        }
      }, 4500))
    },
    handleClick (item) {
      console.log(item)
      window.open(item.jumpUrl)
    },
    doLogin () {
      this.loginDialogShow = true
    },
    doLogin1 () {
      this.loginDialogShow1 = true
    },
    receiveName (val) {
      this.userName = val
      this.$emit('dispatchUserName', val)
    },
    doLogout () {
      sessionStorage.clear()
      this.$router.replace('/')
      this.$nextTick(() => {
        this.$router.go(0)
      })
    }
  },
  computed: {
    list () {
      return this.bannerList.slice(0, 5)
    }
  },
  components: {
    accountCom,
    accountCom1
  }
}
</script>

<style lang="scss">
.my-title--com {
  height: 136px;
  flex: 0 0 118px;
  .title-wrap {
    position: fixed;
    // top: 86.6%;
    top: -10px;
    left: 0;
    width: 100%;
    background: #f2f6fc;
    z-index: 1000;
    box-shadow: 0px 1px 4px #ccc;
    .main-right-user-1 {
      flex: 0 0 auto;
      align-self: center;
      margin-left: 300px;
      padding:0 0 0 800px;
      .link-content-1 {
        z-index: 2000;
        cursor: pointer;
        position:absolute;
        right: 10cm;
        top:19px;
        display: flex;
        margin: 0 0 0 0;
        // margin-top: 24px;
        a {
          padding: 8px 12px;
          cursor: pointer;
          color: #333;
          &.active {
            color: #409EFF;
          }
          &:hover {
            color: #409EFF;
          }
        }
      }
    }
    .small {
      width: 69%;
      position: absolute;
      left: 15%;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, .6);
      font-size: 12px;
      color: #fff;
      padding: 4px 6px;
      cursor: pointer;
    }
    .title-main {
      margin: 0 auto;
      padding: 0 24px;
      display: flex;
      width: 1280px;
      justify-content: space-between;
      .main-left {
        flex: 1 1 1%;
        display: flex;
        align-items: center;
        line-height: 1;
        // margin-left: -230px;
        // margin-bottom: -60px;
        .right {
          margin-left: 12px;
          flex: 1;
          .name {
            color: #333;
            font-size: 18px;
          }
          .des {
            font-size: 12px;
            margin-top: 4px;
            width: 100%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
        img {
          width: 40px;
          margin: 8px 0;
        }
      }
      .main-right-user {
        flex: 0 0 auto;
        align-self: center;
        .link-content {
          span {
            margin: 0 12px;
            font-size: 14px;
            cursor: pointer;
            &:hover {
              color: #409EFF;
            }
          }
        }
      }
      .main-right-home {
        flex: 0 0 auto;
        display: flex;
        flex-direction: column;
        text-align: center;
        align-self: flex-end;
        .link-content {
          display: flex;
          // margin-top: 24px;
          a {
            padding: 8px 12px;
            cursor: pointer;
            color: #333;
            &.active {
              color: #409EFF;
            }
            &:hover {
              color: #409EFF;
            }
          }
        }
      }
    }
    .title-link {
      padding: 0 24px;
      padding-bottom: 8px;
      width: 1280px;
      margin: 0 auto;
      font-size: 12px;
      .link-title {
        color: #83889a;
      }
      a {
        margin-right: 8px;
        color: #409EFF;
      }
    }
  }
  .active {
    color: #409EFF;
    background: #fff;
    border-radius: 4px 4px 0 0;
  }
}
</style>
